// @ts-nocheck

import React from 'react';
import { createGlobalStyle } from 'styled-components';

import fond from '../../../assets/img/grids/gridBackground.jpg';
import { Target } from '../../../client';
import GridsRulesButtonContainer from '../containers/buttons/GridsRulesButtonContainer';

/* add style for mobile, desktop and storybook */
const GlobalStyle = createGlobalStyle`
  html body.grids #app,
  html.app-desktop body.grids #innercontainer #page.betting {
    font-family: BettingPoliticaExtraBold, sans-serif;

    button {
      font-family: BettingPoliticaExtraBold, sans-serif;
    }
  }
`;

const GridDesktopSpecific = createGlobalStyle`
html.app-desktop body.grids #innercontainer {
  background-image: url("${fond}");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;

  #page {
    background: transparent;
  }
}
`;

const GridMobileSpecific = createGlobalStyle`
  html body.grids #app {
    background: ${({ theme }) => theme.grids.colors.black};
  }
`;

const GlobalStyleGrid = ({ children }) => (
  <>
    <GlobalStyle />
    {!Target.__MOBILE__ ? <GridDesktopSpecific /> : <GridMobileSpecific />}
    {children}
    {Target.__MOBILE__ ? <GridsRulesButtonContainer /> : null}
  </>
);

export default GlobalStyleGrid;
